/* =============================================================================
   RANI CUSTOM — Öneri kutusu ürün kodu düzeltmesi      v2 (28 Ağustos 2026)

   SORUN
     Shopify predictive search yazılanı doğrudan ürünlerde aramaz; önce mağazanın
     KAYITLI ARAMA TERİMLERİNE eşler. Daha önce hiç aranmamış bir ürün kodu terim
     listesinde olmadığı için "yazım hatası" sayılıp en yakın bilinen koda çevrilir:
       hc142 → hc141   (HC142 ürünü mevcut olduğu hâlde HC141 gösterilir)

   v1'DE KALAN EKSİK
     İstek, predictive sonucu geldikten SONRA başlıyordu; gecikmeler üst üste binince
     doğru ürün geç düşüyor, kullanıcı o arada yanlış ürüne tıklıyordu.

   v2 DEĞİŞİKLİĞİ
     1) İstek artık tuşa basıldığı anda, predictive ile PARALEL gider (beklemez).
     2) Sorgu joker ile atılır: "hc142*" → hem tam eşleşmeyi ilk sıraya koyar
        hem de "hc14" gibi yarım yazımda HC140/141/142'yi getirir.
     3) Sonuçlar terim bazında önbelleğe alınır; aynı terim için tek istek.

   GÜVENLİK İLKESİ — bu dosya aramayı BOZAMAZ:
     * Yalnızca EKLER. Mevcut sonuçları silmez, değiştirmez, sırasını bozmaz.
     * Yalnızca ürün kodu kalıbındaki sorgularda çalışır (hc142, ba250, ea142...).
       Kelime aramalarına (gardırop, kitaplık) hiç dokunmaz.
     * Aynı ürün kutuda zaten varsa tekrar eklenmez.
     * En fazla 4 kart ekler.
     * Her adım try/catch; selector değişirse / istek başarısızsa / tarayıcı
       desteklemezse sessizce çekilir. theme.js'e DOKUNULMAZ.
   ========================================================================== */
(function () {
  'use strict';

  var BEKLEME_MS  = 120;   // tuş vuruşları arası bekleme
  var EN_FAZLA    = 4;     // eklenecek azami kart
  var KOD_KALIBI  = /^[a-zA-Z]{1,4}\s?-?\s?\d{2,5}[a-zA-Z]?$/;

  var zamanlayici = null;
  var iptalci     = null;
  var onbellek    = {};    // terim -> html

  function sade(s) {
    return (s || '').toString()
      .replace(/İ/g, 'i').replace(/I/g, 'i').replace(/ı/g, 'i')
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function girdi() { return document.querySelector('.search-bar__input'); }
  function kap()   { return document.querySelector('.search-bar__results-inner'); }

  function terim() {
    var i = girdi();
    return i ? i.value.trim() : '';
  }

  function kodMu(t) { return !!t && t.length >= 3 && KOD_KALIBI.test(t); }

  /* Önbellekteki HTML'den, terimi içeren kartları kutunun başına ekle. */
  function bas(t) {
    try {
      var k = kap();
      var html = onbellek[t];
      if (!k || !html) return;
      if (terim() !== t) return;                  // kullanıcı yazmaya devam etti

      var gecici = document.createElement('div');
      gecici.innerHTML = html;

      var s = sade(t);
      var gelen = gecici.querySelectorAll('.search-bar__result-item');
      var uygun = [];
      for (var i = 0; i < gelen.length && uygun.length < EN_FAZLA; i++) {
        if (sade(gelen[i].textContent).indexOf(s) !== -1) uygun.push(gelen[i]);
      }
      if (!uygun.length) return;

      var hedef = k.querySelector('.search-bar__result-products');

      /* Ürün bölümü hiç yoksa (örn. "sonuç yok") başlığıyla birlikte oluştur. */
      if (!hedef) {
        var govde = k.querySelector('.search-ajax') || k;
        var mevcutBaslik = k.querySelector('.search-bar__result-category');
        var baslik = document.createElement('p');
        baslik.className = 'search-bar__result-category';
        baslik.setAttribute('data-rani-duzeltme', '1');
        baslik.textContent = mevcutBaslik ? mevcutBaslik.textContent : 'Ürünler';
        hedef = document.createElement('div');
        hedef.className = 'search-bar__result-products';
        hedef.setAttribute('data-rani-duzeltme', '1');
        govde.insertBefore(hedef, govde.firstChild);
        govde.insertBefore(baslik, hedef);
        var bosluk = govde.querySelector('.search-bar__empty-state');
        if (bosluk) bosluk.style.display = 'none';
      }

      /* Kutuda zaten olan ürünleri tekrar basma. */
      var mevcut = {};
      var linkler = hedef.querySelectorAll('a[href]');
      for (var j = 0; j < linkler.length; j++) {
        mevcut[(linkler[j].getAttribute('href') || '').split('?')[0]] = true;
      }

      for (var n = uygun.length - 1; n >= 0; n--) {
        var yol = (uygun[n].getAttribute('href') || '').split('?')[0];
        if (mevcut[yol]) continue;
        uygun[n].setAttribute('data-rani-duzeltme', '1');
        hedef.insertBefore(uygun[n], hedef.firstChild);
      }
    } catch (e) {}
  }

  /* Terim için sonucu getir (önbellekteyse doğrudan bas). */
  function getir(t) {
    try {
      if (!kodMu(t)) return;
      if (onbellek[t]) { bas(t); return; }
      if (typeof fetch === 'undefined') return;

      if (iptalci) { try { iptalci.abort(); } catch (e) {} }
      var kontrol = null;
      if (typeof AbortController !== 'undefined') {
        kontrol = new AbortController();
        iptalci = kontrol;
      }

      var url = '/search?q=' + encodeURIComponent(t + '*') +
                '&type=product&section_id=predictive-search';

      fetch(url, kontrol ? { signal: kontrol.signal, credentials: 'same-origin' }
                         : { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          onbellek[t] = html;
          bas(t);
        })
        .catch(function () {});
    } catch (e) {}
  }

  function tetikle() {
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(function () { getir(terim()); }, BEKLEME_MS);
  }

  function baslat() {
    try {
      var k = kap(), i = girdi();
      if (!k || !i || typeof MutationObserver === 'undefined') return;

      /* 1) Yazarken: predictive ile paralel istek. */
      i.addEventListener('input', tetikle);

      /* 2) Kutu her yeniden çizildiğinde: elimizde sonuç varsa hemen bas. */
      new MutationObserver(function (kayitlar) {
        for (var a = 0; a < kayitlar.length; a++) {
          var eklenen = kayitlar[a].addedNodes;
          for (var b = 0; b < eklenen.length; b++) {
            var d = eklenen[b];
            if (d.nodeType === 1 && d.getAttribute && d.getAttribute('data-rani-duzeltme')) return;
          }
        }
        var t = terim();
        if (onbellek[t]) bas(t); else getir(t);
      }).observe(k, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
